import React from 'react';
import {
  MarketplaceSingleSelector,
  useAccountInfoContext,
} from '@amzn/aac-marketplace-selector';
import { ThemeProvider } from '@amzn/storm-ui';
import { formatLocale } from 'src/providers/PantherLocalizationProvider/mbm';
import { CountrySwitcherPublisher } from 'src/commons/utils/metrics';
import { useInternalChromeConfigContext } from 'src/providers/InternalChromeConfigContextProvider';

const modifyPopoverZIndex = (theme) => {
  return {
    ...theme,
    modal: {
      ...theme.modal,
      zIndex: 1000,
    },
    popover: {
      ...theme.popover,
      portalElementId: 'AACChromePortal',
      zIndex: 500,
    },
  };
};

export interface MarketplaceSwitcherProps {
  pathOverride?: string;
}

const MarketplaceSwitcher: React.VFC<MarketplaceSwitcherProps> = ({
  pathOverride = '',
}) => {
  const { currentAccount, marketplaces } = useAccountInfoContext();
  const { config: internalChromeConfig } = useInternalChromeConfigContext();

  const handleSelect = (selected) => {
    if (selected?.url) {
      const redirectUrl = new URL(`https://${selected.url}`);

      if (pathOverride !== '') {
        redirectUrl.pathname = pathOverride;
      }

      CountrySwitcherPublisher.publishCounterMonitor('switched', 1);
      window.location.assign(redirectUrl.toString());
    }
  };

  if (
    currentAccount.entityId === undefined ||
    (Array.isArray(marketplaces) && marketplaces.length === 0)
  ) {
    return null;
  }

  CountrySwitcherPublisher.publishCounterMonitor('rendered', 1);

  return (
    <ThemeProvider theme={modifyPopoverZIndex}>
      <MarketplaceSingleSelector
        id="aac-chrome"
        language={formatLocale(internalChromeConfig.locale)}
        onSelect={handleSelect}
      />
    </ThemeProvider>
  );
};

export default MarketplaceSwitcher;
